export function shouldShowPerson(person, data) {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (!person?.isExtraLink) return true;

    if (isMobile && data.hideExtraLinksOnMobile) return false;
    if (!isMobile && data.hideExtraLinksOnDesktop) return false;

    return true;
}
